module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Medium-46420ccb2c7dc13de94669e96baf3fa9.eot";